import React, { useEffect, useState } from "react";
import { ShieldCheck, Clock, Sparkles } from "lucide-react";
import { PRICE } from "@/data/content";
import { useLead } from "@/components/site/LeadContext";

function todayLabel() {
  const d = new Date();
  d.setDate(d.getDate());
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}

function endOfToday() {
  const d = new Date();
  d.setDate(d.getDate());
  d.setHours(23, 59, 59, 999);
  return d.getTime();
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function Countdown() {
  const [target] = useState(endOfToday);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, target - now);
  const h = Math.floor(diff / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1000);

  return (
    <div className="mt-3 flex items-center justify-center gap-1.5 text-brand-red" data-testid="offer-countdown">
      <span className="text-[10px] font-bold uppercase tracking-widest text-brand-navy/70">
        Termina em
      </span>
      <span className="rounded-md bg-brand-red/10 px-2 py-1 font-mono text-sm font-black tabular-nums text-brand-red">
        {pad(h)}
      </span>
      <span className="font-black text-brand-red">:</span>
      <span className="rounded-md bg-brand-red/10 px-2 py-1 font-mono text-sm font-black tabular-nums text-brand-red">
        {pad(m)}
      </span>
      <span className="font-black text-brand-red">:</span>
      <span className="rounded-md bg-brand-red/10 px-2 py-1 font-mono text-sm font-black tabular-nums text-brand-red">
        {pad(s)}
      </span>
    </div>
  );
}

export default function OfferCard({ source = "pricing", testid = "offer-card" }) {
  const { openLead } = useLead();
  const limit = todayLabel();
  return (
    <div className="relative overflow-hidden rounded-[2rem] bg-white p-8 text-center shadow-2xl shadow-black/40 sm:p-10" data-testid={testid}>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-red/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-brand-red">
          Valor promocional 2º lote
        </span>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-red/10 px-3 py-1.5 text-xs font-bold text-brand-red">
          <Clock className="h-3.5 w-3.5" /> Só até hoje, dia {limit}
        </span>
      </div>

      <Countdown />

      {/* Preço com destaque no "de/por" */}
      <div className="mt-6 text-center">
        <p className="font-display text-3xl font-black leading-none text-slate-400 sm:text-4xl">
          <span className="line-through">{PRICE.old}</span>{" "}
          <span className="whitespace-nowrap text-base font-bold text-brand-navy/70 sm:text-lg">
            por apenas
          </span>
        </p>
        <div className="mt-2 flex items-baseline justify-center gap-2">
          <span className="font-display text-6xl font-black text-brand-navy sm:text-7xl">
            {PRICE.now}
          </span>
        </div>
        <p className="mt-2 text-xs font-semibold text-brand-navy/60 sm:text-sm">
          em até 10x de R$ 58 <strong className="font-black uppercase text-brand-red">sem juros</strong> no cartão
        </p>
        <p className="mx-auto mt-3 flex w-fit flex-col items-center gap-0.5 rounded-3xl bg-sun/15 px-4 py-2 text-center font-display text-base font-black uppercase tracking-tight text-brand-navy sm:text-lg">
          Valor válido para 2 pessoas
          <span className="text-xs font-bold normal-case tracking-normal text-brand-navy/80 sm:text-sm">
            Um ano para escolher a melhor data e agendar seu mergulho
          </span>
        </p>
      </div>

      <button
        onClick={() => openLead(source)}
        className="cta-sun botao-pulsante animate-pulse-glow mt-8 flex w-full items-center justify-center rounded-full px-8 py-5 text-base font-extrabold uppercase tracking-wide text-white sm:text-lg"
        data-testid={`${testid}-cta`}
      >
        Garantir ingresso na promoção
      </button>

      <p className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ocean-mid/10 px-4 py-2 text-center text-xs font-black uppercase tracking-wider text-ocean-mid sm:text-sm">
        <Sparkles className="h-4 w-4" />
        Novidade: compre quantos ingressos quiser com 50% de desconto
      </p>

      <p className="mt-4 rounded-xl bg-brand-red/5 px-4 py-3 text-center text-sm font-semibold text-brand-red">
        Depois deste lote, o valor sobe para {PRICE.secondLot}. Garanta agora no menor preço.
      </p>

      <div className="mt-4 flex items-center justify-center gap-2 text-sm text-muted-foreground">
        <ShieldCheck className="h-4 w-4 text-ocean-mid" />
        Compra segura · Ingresso válido por 1 ano
      </div>
    </div>
  );
}